<template>
  <div class="flex-row">
    <Info :process="process" @refresh="showLog" />
    <div class="timeline">
      <Timeline :process="process" />
    </div>
  </div>
</template>

<script>
import Service from '../../../../services/MonitoringLegacyService'
import Utils from '../../utils'
import Info from './Info.vue'
import Timeline from './Timeline.vue'

export default {
  name: 'ProcessLog',

  components: { Info, Timeline },

  data: () => ({
    Utils,
    process: {},
    processList: [
      { label: 'Consulta Api', value: 'consultaapi' },
      { label: 'Job Envia Dados Rest', value: 'jobenviadadosrest' },
      { label: 'Job Envia Dados Rest', value: 'jobenviadadossoap' },
      { label: 'Rest to Soap', value: 'resttosoap' },
      { label: 'Workflow', value: 'workflow' }
    ]
  }),

  mounted () {
    if (this.$route.params.processType) {
      this.searchObject = this.$route.params
      this.process = this.searchObject.processType
    }
    this.showLog()
  },

  computed: {
    canShowLog () {
      const { processType, jobIdentifier, date, id } = this.$route.query
      return processType && jobIdentifier && date && id
    }
  },

  methods: {
    showLog () {
      if (!this.canShowLog) return console.error(this.$t('warnings.error.not_enough_data'))
      const { processType, jobIdentifier, date, id } = this.$route.query

      Service.readProcess(processType, jobIdentifier, date, id)
        .then(({ data }) => { this.process = data })
        .catch((err) => console.error(this.$t('warnings.error.occurred'), err))
    }
  }
}
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
}
.timeline {
  height: calc(100vh - 64px);
  overflow: auto;
  padding: 0 10px;
  width: 100%;
}
</style>
